import { render, staticRenderFns } from "./relations.vue?vue&type=template&id=815306ae"
import script from "./relations.vue?vue&type=script&lang=js"
export * from "./relations.vue?vue&type=script&lang=js"
import style0 from "./relations.vue?vue&type=style&index=0&id=815306ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports